module.exports = __webpack_public_path__ + "media/assets/images/flags/et-0cda995a0d6ee9862bcb47e1fdf3b0b1.svg";